
















import Vue from "vue";
import * as routes from "@/router/routes";

// Vue components
import StandardPage from "@/components/PageTemplates/StandardPage.vue";
import EcrMainTable from "./EcrMainTable.vue";
import EcrToolbar from "./EcrToolbar.vue";

// Model
import { dataTableItemsPerPage } from "@/utility/Constants";
import { GetInstallationsEcrDataReqData } from "@/model/communication/ecr/GetInstallationsEcrDataReqData";
import { GetInstallationsEcrDataResData } from "@/model/communication/ecr/GetInstallationsEcrDataResData";
import { GetInstallationsEcrDataCommand } from "@/model/communication/ecr/GetInstallationsEcrDataCommand";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { DownloadInstallationsEcrDataCommand } from "@/model/communication/ecr/DownloadInstallationsEcrDataCommand";

export default Vue.extend({
    components: {
        StandardPage,
        EcrToolbar,
    },
    data() {
        return {
            routes,
            dataTableItemsPerPage,
            EcrMainTable,
            loading: false,
            reqData: null,
            installations: [],
            paginatedTotalItems: null,
        };
    },
    methods: {
        async sendRequest(request) {
            try {
                this.reqData = request;
                this.loading = true;
                var response: GetInstallationsEcrDataResData = await new GetInstallationsEcrDataCommand(request).execute();
                this.loading = false;

                if (response.responseStatus == ApiResponseStatusEnum.Success) {
                    this.installations = response.installationsEcrDataList;
                    this.paginatedTotalItems = response.paginatedTotalItems;
                }
            } catch (e) {
                console.log("Something went wrong sending GetInstallationsEnabledModules request ", e);
                this.loading = false;
            }
        },

        async onDownload(exportType) {
            console.log("Download required, exportType: ", exportType);
            if (!this.loading) {
                this.loading = true;
                try {
                    const res = await new DownloadInstallationsEcrDataCommand(this.reqData, exportType).execute();

                    var fileURL = window.URL.createObjectURL(new Blob([res.data]));
                    var fileLink = document.createElement("a");
                    fileLink.href = fileURL;
                    fileLink.setAttribute("download", res.headers["content-disposition"].substring("attachment; filename=".length));
                    document.body.appendChild(fileLink);
                    fileLink.click();
                    this.loading = false;
                } catch (e) {
                    console.log("Something went wrong during DownloadInstallationsEcrDataCommand execution: ", e);
                    this.loading = false;
                }
            }
        },

        async onRefresh() {
            this.sendRequest(this.reqData);
        },
    },
    mounted() {
        this.reqData = new GetInstallationsEcrDataReqData();
        this.reqData.queryLimit = this.dataTableItemsPerPage[0];
    },
});
